import { render, staticRenderFns } from "./viewInnerPages.vue?vue&type=template&id=260f1e2c&scoped=true&"
import script from "./viewInnerPages.vue?vue&type=script&lang=ts&"
export * from "./viewInnerPages.vue?vue&type=script&lang=ts&"
import style0 from "./viewInnerPages.vue?vue&type=style&index=0&id=260f1e2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260f1e2c",
  null
  
)

export default component.exports